/* eslint-disable react/jsx-props-no-spreading */
import React, { createContext, Dispatch, PropsWithChildren, SetStateAction, useState } from 'react';

export function contextProvider<A>(defaultValue: A) {
  type UpdateType = Dispatch<SetStateAction<typeof defaultValue>>;
  const defaultUpdate: UpdateType = () => defaultValue;
  const ctx = createContext({
    ctxState: defaultValue,
    ctxUpdate: defaultUpdate,
  });

  const Provider = (props: PropsWithChildren<{}>) => {
    const [ctxState, ctxUpdate] = useState(defaultValue);

    // eslint-disable-next-line react/jsx-no-constructed-context-values
    return <ctx.Provider value={{ ctxState, ctxUpdate }} {...props} />;
  };
  return [ctx, Provider] as const; // alternatively, [typeof ctx, typeof Provider]
}
